import React, { useState } from "react";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import { Loader, Dimmer, Message } from "semantic-ui-react";
import "./styles.css";
const DeleteModal = ({
  openModal,
  event,
  removeAddress,
  myAddress,
  setMyAddress,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setDisabled(true);
      setError("");
      await removeAddress(myAddress.addressId);
      setSuccess(true);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
      setDisabled(false);
      window.setTimeout(() => {
        clean();
      }, 2000);
    }
  };

  const clean = () => {
    setMyAddress({});
    event(!openModal);
    setSuccess(false);
    setError("");
  };

  return (
    <MDBContainer>
      <MDBModal isOpen={openModal} toggle={() => clean()}>
        <MDBModalHeader toggle={() => clean()}>
          <p>
            ¿Está seguro(a) de eliminar la dirección{" "}
            <strong style={{ fontWeight: "bold" }}>{myAddress.name}</strong>?
          </p>
        </MDBModalHeader>
        <MDBModalFooter>
          {loading && (
            <Dimmer active inverted>
              <Loader size="mini" />
            </Dimmer>
          )}
          <div className="delete-modal-messages">
            {error && (
              <Message error size="mini" header="Oops!" content={error || ""} />
            )}
            {success && (
              <Message
                info
                icon="check"
                header="Éxito"
                content={`Se eliminó la dirección: ${myAddress.name}`}
              />
            )}
            <div className="ui two buttons">
              <MDBBtn
                color="red"
                onClick={() => handleSubmit()}
                disabled={disabled || loading}
              >
                Eliminar
              </MDBBtn>
              <MDBBtn color="dark" onClick={() => clean()}>
                Cancelar
              </MDBBtn>
            </div>
          </div>
        </MDBModalFooter>
      </MDBModal>
    </MDBContainer>
  );
};

export default DeleteModal;
